module.exports = __webpack_public_path__ + "bootstrap.min.js";


//////////////////
// WEBPACK FOOTER
// ../node_modules/file-loader/dist/cjs.js?name=[name].[ext]!../node_modules/bootstrap/dist/js/bootstrap.min.js
// module id = 547
// module chunks = 0